import { createRoot } from "react-dom/client";
import { App } from "./App";
import { chrome } from "./spiel/chrome";

console.log(`%c${chrome.devtoolsTaunt}`, chrome.devtoolsTauntStyle);

const root = document.getElementById("root");

if (root) {
  createRoot(root).render(<App />);
}
